import React from "react";

const NoHandsAvailable = (props) => {
    return (<div className="NoHnadsFound_wrap">
        <img alt="noHandsAvailableImage" className="empty_handList_image" src="/images/MyHands/NoHands.png" />
        <div className="No_Hnads_Available_text">{props.i18next.t("lable.noHandsAvailable")}</div>
        <div className="Try_changing_your_text">{props.i18next.t("lable.tryChagingYour")} <span data-e2e="filterLink" className="filtersLink" onClick={(e) => {
            e.preventDefault()
            props.setShowFilterModal(true)
        }} data-e2e="change-filter">{props.i18next.t("lable.filters")}</span></div>
    </div>)
}
export default NoHandsAvailable;


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/NoHandsAvailable.js
 **/